import React from 'react'
import { Carousel } from 'react-bootstrap'
import { PropertyCardSliderDefaultImg } from '../../helper/imagepath'
import { appendImageURL } from '../../helper/function'

const CustomImageCarousel = ({ imageList }) => {
  return (
    <Carousel data-bs-theme="dark" style={{ width: '80%' }}>
      {imageList?.length > 0 ? (
        imageList.map((image, index) => (
          <Carousel.Item key={index}>
            <img className={`property_slider_img`} src={image ? appendImageURL(image) : PropertyCardSliderDefaultImg} alt="not found" />
          </Carousel.Item>
        ))
      ) : (
        <Carousel.Item>
          <img className={`property_slider_img`} src={PropertyCardSliderDefaultImg} alt="not found" />
        </Carousel.Item>
      )}
    </Carousel>
  )
}
export default CustomImageCarousel
